import React, { useState } from "react";
import { getFluxxUserId } from "@/services/postLoginUser";

type Props = {
  members: any[];
};

const FluxxConfig: React.FC<Props> = ({ members }) => {
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedUserName, setSelectedUserName] = useState("");
  const [fluxxId, setFluxxId] = useState("");
  const [result, setResult] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const handleCheck = async (upn: string) => {
    const user = members.find((m) => m.userPrincipalName === upn);

    setSelectedUser(upn);
    setSelectedUserName(user?.displayName || upn);
    setFluxxId("");
    setResult("");
    setLoading(true);

    try {
      const res = await getFluxxUserId(upn);
      const id = res?.userId || res?.data?.userId || res?.data?.id;

      if (id) {
        setFluxxId(id);
        setResult(`${user?.displayName || upn} has Fluxx access`);
      } else {
        setResult(`${user?.displayName || upn} does not have Fluxx access`);
      }
    } catch {
      setResult("Unable to verify Fluxx access. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border border-gray-200 rounded-md bg-[#fbfaf7] p-4 space-y-4">

         <div className="text-sm">
        {!selectedUser && (
          <div className="text-gray-500">
            Select a user to check Fluxx access
          </div>
        )}

        {selectedUser && loading && (
          <div className="text-gray-500">Checking...</div>
        )}

        {!loading && result && (
          <div
            className={`${
              result.includes("has Fluxx")
                ? "text-green-600 bg-green-50 border border-green-200"
                : "text-rose-600 bg-rose-50 border border-rose-200"
            } px-3 py-2 rounded-md`}
          >
            {result}
          </div>
        )}
      </div>
      
      <select
        className="w-full border border-gray-200 p-2 rounded focus:outline-none focus:ring-2 focus:ring-orange-400"
        value={selectedUser}
        onChange={(e) => handleCheck(e.target.value)}
      >
        <option value="">Select User</option>
        {members.map((m) => (
          <option key={m.id} value={m.userPrincipalName}>
            {m.displayName || m.userPrincipalName}
          </option>
        ))}
      </select>

     

      {fluxxId && (
        <div className="text-xs text-gray-600">
          Fluxx ID: <span className="font-semibold text-gray-800">{fluxxId}</span>
        </div>
      )}

    </div>
  );
};

export default FluxxConfig;